var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWifi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40,18.75A42.17459,42.17459,0,0,1,69.479,30.53955l1.042-1.0791A43.66686,43.66686,0,0,0,40,17.25,43.66686,43.66686,0,0,0,9.479,29.46045l1.042,1.0791A42.17459,42.17459,0,0,1,40,18.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.521,39.46045a29.75007,29.75007,0,0,0-41.042,0l1.042,1.0791a28.24993,28.24993,0,0,1,38.958,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.521,49.46045a15.25007,15.25007,0,0,0-21.042,0l1.042,1.0791a13.74993,13.74993,0,0,1,18.958,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.25,60A2.75,2.75,0,1,0,40,57.25,2.7528,2.7528,0,0,0,37.25,60Zm4,0A1.25,1.25,0,1,1,40,58.75,1.25116,1.25116,0,0,1,41.25,60Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWifi);
export default __webpack_public_path__ + "static/media/icon_wifi.a7af41a1ae524874a2050e687d015542.svg";
export { ForwardRef as ReactComponent };